// src/components/ResultPage.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ResultQuiz from "./ResultQuiz";
import ResultSurvey from "./ResultSurvey";
import { Breadcrumb } from "components";
import { translate } from "react-switch-lang";
import "./ResultPage.scss";
import LeaderBoard from "./LeaderBoard";
import api from "../api/api";
import { Spinner } from "reactstrap";

const ResultPage = ({ t }) => {
  const { id, type } = useParams();
  const [results, setResults] = useState(null);
  const [score, setScore] = useState(null);
  const [maxScore, setMaxScore] = useState(null);
  const [loading, setLoading] = useState(true);
  const userRole = localStorage.getItem("userRole");
  const title = localStorage.getItem("Title");
  const [exportLoading, setExportLoading] = useState(false);
  const userId = localStorage.getItem("userId");

  const isAdmin = userRole === "ADMIN";

  const handleExcelExport = async () => {
    if (exportLoading) return;

    try {
      setExportLoading(true);
      if (type === "quiz" || type === "survey") {
        await api.downloadParticipationExcel(id);
      }
    } catch (err) {
      console.error("Excel export failed", err);
    } finally {
      setExportLoading(false);
    }
  };

  useEffect(() => {
    let ignore = false; // prevent race condition

    const fetchData = async () => {
      try {
        const { data } = await api.fetchResults(type, id, userRole, userId);
        if (ignore) return;

        if (type === "quiz") {
          setResults({
            userData: data.data,
            adminData: isAdmin ? data.data : null,
          });
        } else {
          setResults({ surveyData: data.data });
        }
      } catch (err) {
        if (!ignore) console.error("Failed to fetch results");
      } finally {
        if (!ignore) setLoading(false);
      }
    };

    fetchData();
    return () => {
      ignore = true;
    }; // cleanup
  }, [id, type]); // 👈 only depend on id & type

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Spinner
          animation="border"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        />
      </div>
    );
  }

  return (
    <>
      <Breadcrumb title={t(title)} />
      <div className="result-container">
        {type === "quiz" && (
          <div className="leaderboard-section">
            <LeaderBoard quizId={id} />
          </div>
        )}

        {type === "quiz" ? (
          <ResultQuiz
            userdata={results?.userData}
            isAdmin={isAdmin}
            adminData={results?.adminData}
          />
        ) : (
          <ResultSurvey results={results} isAdmin={isAdmin} />
        )}

        {results && (
          <div className="export-buttons">
            {/* <button onClick={() => handleExport("csv")}>📥 Export CSV</button>
            <button onClick={() => handleExport("json")}>📥 Export JSON</button> */}
            {isAdmin && (
              <button onClick={handleExcelExport} disabled={exportLoading}>
                {exportLoading ? (
                  <>
                    <Spinner size="sm" /> Exporting...
                  </>
                ) : (
                  <>📊 Export Excel</>
                )}
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default translate(ResultPage);
